import React from 'react';
import { Container } from 'react-bootstrap';
import { LOCAL_CONSTANT } from '../localConstant';

/**
 * フッターコンポーネントです。
 * @returns {JSX.Element} - JSX要素
 */
const Footer: React.FC = () => {
  return (
    <footer className="pt-1 pb-3">
      <Container>
        <div className="text-end small text-white">
          <span>{`バージョン：${LOCAL_CONSTANT.VERSION}`}</span>
        </div>
        <div className="text-white text-center">
          <span>Copyright Ⓒ Japan Patent office. All Rights Reserved.</span>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;